import React, { useState } from 'react'
import RadioButton from '../../../../components/RadioButton/RadioButton'
import Text from '../../../../components/Text'
import NotPurchased from './NotPurchased'
// import * as actions from '../../../../store/slices'
// import { useDispatch } from 'react-redux'
import ProceedButton from '../../../../components/Signup/ProceedButton'

const HaveProductPurchased = ({ onMoveNext, isLastStep, isLoading }) => {
  const [selectedValue, setSelectedValue] = useState(0)
  const [selecteOption, setSelecteOption] = useState(0)
  // const dispatch = useDispatch()

  const handleChange = () => {
    if (onMoveNext && selecteOption === 1) {
      onMoveNext(selecteOption)
    } else {
      setSelectedValue(selecteOption)
    }
  }
  const handleCloseNotPurchased = () => {
    setSelectedValue(0)
    setSelecteOption(0)
  }

  // const handleVerifyCode = (code) => {
  //   onMoveNext(code)
  //   dispatch(actions.resetVerifyCodeData())
  // }

  return (
    <div className="z-10 pt-12 px-4">
      <Text
        variant="display"
        size="small"
        className="text-[#101828] mb-4"
        tag="h2"
      >
        Have you purchased Viemax Product?
      </Text>

      <div className="flex flex-col gap-4 mt-12">
        <RadioButton
          className="w-full"
          label="Yes"
          isSelected={selecteOption === 1}
          onClick={() => setSelecteOption(1)}
        />
        <RadioButton
          className="w-full"
          label="No"
          isSelected={selecteOption === 2}
          onClick={() => setSelecteOption(2)}
        />
      </div>

      <ProceedButton
        onMoveNext={handleChange}
        isLastStep={isLastStep}
        disabled={!selecteOption || isLoading}
        btnText={isLoading ? 'Verifying...' : null}
      />

      <NotPurchased
        isOpen={selectedValue === 2}
        onClose={handleCloseNotPurchased}
      />
    </div>
  )
}

export default HaveProductPurchased
